export const INLINE_1 = 'inline1';
export const INLINE_2 = 'inline2';
export const INLINE_3 = 'inline3';
export const INLINE_4 = 'inline4';
export const COLUMN_1 = 'column1';
export const COLUMN_2 = 'column2';
export const COLUMN_3 = 'column3';
export const COMPOSITE_1 = 'composite1';
